import type { SiteContent } from '../content/types';
import { Container } from '../components/layout/container';
import { PageHero } from '../components/sections/page-hero';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

interface PraxisPageProps {
  content: SiteContent;
}

export function PraxisPage({ content }: PraxisPageProps): JSX.Element {
  return (
    <>
      <PageHero title={content.praxisPage.heroTitle} text={content.praxisPage.heroText} />
      <section className="pb-12 sm:pb-16">
        <Container className="space-y-8">
          <div className="grid gap-4 md:grid-cols-2">
            {content.praxisPage.sections.map((section) => (
              <Card key={section.title} className="h-full bg-white">
                <CardHeader className="pb-2">
                  <CardTitle className="text-base">{section.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm leading-relaxed text-[color:var(--color-muted)]">{section.text}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="grid gap-4 md:grid-cols-3">
            {content.praxisPage.gallery.map((item) => (
              <Card key={item.label} className="overflow-hidden bg-white">
                <div className="aspect-[4/3] bg-[linear-gradient(145deg,var(--color-primary-soft),var(--color-accent))] p-4">
                  <div className="flex h-full items-end rounded-xl border border-white/70 bg-white/70 p-4 text-sm font-semibold text-[color:var(--color-text)] backdrop-blur">
                    {item.label}
                  </div>
                </div>
              </Card>
            ))}
          </div>

          <Card className="bg-[color:var(--color-surface-alt)]">
            <CardContent className="p-6 text-sm text-[color:var(--color-muted)]">{content.praxisPage.placeholderNotice}</CardContent>
          </Card>
        </Container>
      </section>
    </>
  );
}
